"use client";

import Link from "next/link";
import { PlusIcon } from "lucide-react";
import CustomerMobileMenu from "./mobile-menu";
import HeaderShell from "@/components/header/header-shell";
import HeaderBrand from "@/components/header/header-brand";
import HeaderAuthSection from "@/components/header/header-auth-section";
import { useHeaderAuth } from "@/components/header/use-header-auth";
import { getAgencyDisplayName } from "@/components/header/utils";

interface Props {
  profile: any;
}

export default function CustomerHeader({ profile }: Readonly<Props>) {
  const auth = useHeaderAuth("/customer/landing");
  const agencyName = getAgencyDisplayName(profile);

  return (
    <HeaderShell>
      <div className="flex items-center">
        <div className="md:hidden ml-auto">
          <CustomerMobileMenu isLoggedIn={auth.isLoggedIn} />
        </div>
        <HeaderBrand
          href="/customer/landing"
          name={agencyName}
          logoSrc={profile?.logo}
        />

        <nav className="hidden md:flex items-center gap-8 text-ordinary text-base font-bold mr-10">
          <Link href="/advertisements-consultants/advertisements-filter/list">
            آگهی ها
          </Link>
          <Link href="/customer/consultants">مشاوران</Link>
          <Link href="/articles">وبلاگ</Link>
          <Link href="/customer/about">درباره ما</Link>
          <Link href="/customer/contact-us">ارتباط با ما</Link>
          {auth.isLoggedIn && <Link href="/create-ads">ثبت آگهی</Link>}
        </nav>
      </div>

      <HeaderAuthSection
        auth={auth}
        className={`flex gap-3 md:gap-4 mr-auto ${auth.isLoggedIn ? "items-end" : "items-center"}`}
        loggedOutContent={
          <>
            <Link
              href="/login-otp"
              className="hidden md:inline font-medium bg-transparent text-primary text-sm md:text-base hover:text-brand-700 transition-colors"
            >
              ورود / ثبت نام
            </Link>
            <Link
              href="/create-ads"
              className="hidden md:flex items-center justify-center gap-2 
                w-36 h-10 md:h-12 bg-primary
                text-sm md:text-base hover:bg-brand-700 
                text-white font-normal rounded-[50px] 
                transition-colors"
            >
              <PlusIcon />
              ثبت آگهی
            </Link>
          </>
        }
      />
    </HeaderShell>
  );
}
